export const LOCALIZED_HOST_BY_COUNTRY: Record<string, string> = {
  AE: "ae.urbanarmorgear.com",
  AR: "ar.urbanarmorgear.com",
  AU: "au.urbanarmorgear.com",
  BR: "br.urbanarmorgear.com",
  CA: "www.urbanarmorgear.ca",
  CL: "cl.urbanarmorgear.com",
  DE: "de.urbanarmorgear.com",
  ES: "es.urbanarmorgear.com",
  FR: "fr.urbanarmorgear.com",
  GB: "www.urbanarmorgear.co",
  HK: "hk.urbanarmorgear.com",
  ID: "id.urbanarmorgear.com",
  IN: "www.urbanarmorgear.in",
  IT: "it.urbanarmorgear.com",
  JP: "jp.urbanarmorgear.com",
  MX: "www.urbanarmorgear.mx",
  MY: "my.urbanarmorgear.com",
  NL: "nl.urbanarmorgear.com",
  NZ: "www.urbanarmorgear.co", // Shared with GB
  PH: "www.urbanarmorgear.ph",
  SG: "sg.urbanarmorgear.com",
  TH: "th.urbanarmorgear.com",
  TW: "www.urbanarmorgear.tw",
  VN: "vn.urbanarmorgear.com",
}

// Primary/US hosts
export const PRIMARY_HOSTS = new Set([
  "urbanarmorgear.com",
  "www.urbanarmorgear.com",
])

export const LOCALIZED_HOST_SET = new Set(
  Object.values(LOCALIZED_HOST_BY_COUNTRY).map((h) => h.toLowerCase())
)

// Reverse maps
export const HOST_TO_COUNTRY: Record<string, string> = {}
export const MULTI_COUNTRY_HOSTS: Record<string, string[]> = {}
;(function buildReverse() {
  const byHost: Record<string, string[]> = {}
  for (const [cc, host] of Object.entries(LOCALIZED_HOST_BY_COUNTRY)) {
    const k = host.toLowerCase()
    byHost[k] = byHost[k] ? [...byHost[k], cc] : [cc]
  }
  for (const [host, list] of Object.entries(byHost)) {
    if (list.length === 1) {
      HOST_TO_COUNTRY[host] = list[0]
    } else {
      MULTI_COUNTRY_HOSTS[host] = list
      HOST_TO_COUNTRY[host] = list[0]
    }
  }
})()
